import api from 'configs/api';
import { IRequestResponse } from 'interfaces/RequestResponse';
import {
  IGridDataResponse,
  IGridPredictionChromatographicData,
  IGridVariationData,
  IExportGridData,
} from 'interfaces/Grid';
import { IGraphChromatographicDataProps } from 'components/molecules/PredictionGrid/components/ContainerGraphChromatographic/GraphChromatographic/types';

const endpointUrl = 'prediction/';

export const postGridChromatographic = async (qs, params) => {
  const url = `${endpointUrl}grid/filter-chromatographic?${qs}`;
  const { data } = await api.post<
    IRequestResponse<IGridDataResponse<IGridPredictionChromatographicData[]>>
  >(url, params);
  return data;
};

export const putGridChromatografic = async params => {
  const url = `${endpointUrl}chromatographic`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};

export const postGridVariation = async params => {
  const url = `${endpointUrl}grid/chromatographic/variation`;
  const { data } = await api.post<IRequestResponse<IGridVariationData[]>>(
    url,
    params,
  );
  return data;
};

export const postExportChromatograficGrid = async params => {
  const url = `${endpointUrl}grid/chromatographic/excel?`;
  const { data } = await api.post<IExportGridData>(url, params);
  return data;
};

export const postGraphicChromatographic = async params => {
  const url = `${endpointUrl}grid/chromatographic/graphic`;
  const { data } = await api.post<
    IRequestResponse<IGraphChromatographicDataProps[]>
  >(url, params);
  return data;
};
